import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../../fetch';

import reqwest from 'reqwest';





const insertFileData = (data, projectId) => {

	const formData = new FormData();

	data.fileData.forEach(file => {
		formData.append('achievementFiles', file[0]);
	});

	if (data.hasFilesData) {
		formData.append('achievementHasFiles', JSON.stringify(data.hasFilesData))
	}

	reqwest({
		url: fetch.base + '/ky/achievement/researchReport/insertFileData/' + projectId,
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {

			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '文件上传',
					content: '文件上传成功！',
					onOk:() => {
					}
				});
			} else {
				Modal.error({
					title: '文件上传',
					content: data.message,
					onOk:() => {
					}
				});
			}


		},
	});
}


const declareProject = (data) => {

	const formData = new FormData();

	formData.append('achievementBase', JSON.stringify(data.baseData))
	formData.append('achievementMember', JSON.stringify(data.memberData))
	formData.append('projectData', JSON.stringify(data.projectData))
	if (data.hasFilesData) {
		formData.append('achievementHasFiles', JSON.stringify(data.hasFilesData))
	}
	formData.append('type', data.type)

	data.filesData.forEach(file => {
		formData.append('achievementFiles', file);
	});

	return reqwest({
		url: fetch.base + 'ky/achievement/researchReport/declareProject',
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {

			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '研究报告申报成功',
					content: data.message,
					onOk:() => {
					}
				});
			} else if (data.code === 201) {
				return response
			}
			else {
				Modal.error({
					title: '研究报告申报失败',
					content: data.message,
					onOk:() => {
					}
				});
			}
		},
	});
}


const editProject = (data) => {

	const formData = new FormData();

	formData.append('achievementBase', JSON.stringify(data.baseData))
	formData.append('achievementMember', JSON.stringify(data.memberData))
	formData.append('projectData', JSON.stringify(data.projectData))
	if (data.hasFilesData) {
		formData.append('achievementHasFiles', JSON.stringify(data.hasFilesData))
	}
	formData.append('type', data.type)


	data.filesData.forEach(file => {
		formData.append('achievementFiles', file);
	});
	return reqwest({
		url: fetch.base + 'ky/achievement/researchReport/edit',
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {
			
			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '研究报告申报成功',
					content: data.message,
					onOk:() => {
					}
				});
			} else if (data.code === 201) {
				Modal.success({
					title: '研究报告编辑成功',
					content: data.message,
					onOk:() => {
					}
				});
			}
			else {
				Modal.error({
					title: '研究报告编辑失败',
					content: data.message,
					onOk:() => {
					}
				});
			}
		},
	});
}



export default {
	insertFileData,
	declareProject,
	editProject,
}